import { render, staticRenderFns } from "./ProfitBalance.vue?vue&type=template&id=004a074d&scoped=true&"
import script from "./ProfitBalance.vue?vue&type=script&lang=js&"
export * from "./ProfitBalance.vue?vue&type=script&lang=js&"
import style0 from "./ProfitBalance.vue?vue&type=style&index=0&id=004a074d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a074d",
  null
  
)

export default component.exports